import * as Yup from 'yup';
import {
  VACATION_DESCRIPTION_MAX,
  TEXT_FIELD_REGEX,
  TEXT_FIELD_MESSAGE,
} from 'constants/fieldLimits';

const greaterThanZeroRegExp = /^[1-9][0-9]*$/;

const vacationValidationSchema = Yup.object().shape({
  startDate: Yup.date().nullable().required('Start date is required'),
  endDate: Yup.date().nullable().required('End date is required'),
  description: Yup.string()
    .required('Description is required')
    .max(
      VACATION_DESCRIPTION_MAX,
      `Description must be ${VACATION_DESCRIPTION_MAX} characters or less`,
    )
    .matches(TEXT_FIELD_REGEX, TEXT_FIELD_MESSAGE),
  workingDays: Yup.string()
    .matches(greaterThanZeroRegExp, 'The number should be greater than 0')
    .required('Number of working days is required'),
});

export default vacationValidationSchema;
